import { API_NAMES } from "./apiNames";
import { PRODUCT_NAMES } from "../../constants/productNames";

export const FILE_TYPES = {
  PDF: "pdf",
  IMAGE: "image",
  FILE: "file",
};

export const FILES_BY_API = {
  [API_NAMES.DS160]: {
    application: {
      type: FILE_TYPES.PDF,
    },
    confirmation: {
      type: FILE_TYPES.PDF,
    },
    portrait: {
      type: FILE_TYPES.IMAGE,
    },
  },
  [API_NAMES.ESTA]: {
    passport: {
      type: FILE_TYPES.IMAGE,
    },
  },
  [PRODUCT_NAMES.NZ]: {
    portrait: {
      type: FILE_TYPES.IMAGE,
    },
  },
  [PRODUCT_NAMES.IND]: {
    portrait: {
      type: FILE_TYPES.IMAGE,
    },
  },
  [PRODUCT_NAMES.VN]: {
    portrait: {
      type: FILE_TYPES.IMAGE,
    },
  },
  [PRODUCT_NAMES.DS82]: {
    passport: {
      type: FILE_TYPES.IMAGE,
    }
  },
  [PRODUCT_NAMES.DS11]: {
    passport: {
      type: FILE_TYPES.IMAGE,
    }
  },
};
